import React, { useState } from "react";

import { Divider, DividerProps, Tab, Tabs } from "@mui/material";
import { SimpleHeadMui } from "components/Simple-head/SimpleHeadMui";

import { CarriedForm } from "./CarriedForm";
import { FeesForm } from "./FeesForm";

interface Props {
  onClose: () => void;
}

const dividerProps: DividerProps = {
  orientation: "vertical",
  sx: { width: "1px", height: "16px", bgcolor: "#dae0e2" }
};

type TabType = "fees" | "interests";

export const Content: React.FC<Props> = ({ onClose }) => {
  const [currentTab, setCurrentTab] = useState<TabType>("fees");

  const handleChangeTab = (_: React.SyntheticEvent, newValue: TabType) => {
    setCurrentTab(newValue);
  };

  return (
    <>
      <SimpleHeadMui onIconClick={onClose}>Fees</SimpleHeadMui>
      <Tabs
        classes={{
          indicator: "indicator" // classes for custom indicator
        }}
        sx={{
          minHeight: "24px",
          m: "20px 20px 0 20px",
          borderBottom: 1,
          borderColor: "#dae0e2",
          button: {
            p: 0,
            minHeight: "20px",
            fontWeight: "normal",
            color: "#5d7782",
            fontSize: "15px"
          },
          ".MuiTabs-flexContainer": {
            alignItems: "center",
            gap: "15px"
          },
          // This is styling if custom indicator
          "& .indicator": {
            display: "flex",
            justifyContent: "center",
            backgroundColor: "transparent",
            "& > span": {
              width: "98%", // Reduce indicator width
              backgroundColor: "#0a3142"
              // transform: "translateX(7px)" // Offset to the right
            }
          }
        }}
        value={currentTab}
        onChange={handleChangeTab}
        TabIndicatorProps={{ children: <span /> }}
      >
        <Tab label="Management Fees" value="fees" />
        <Divider {...dividerProps} />
        <Tab label="Carried Interests" value="interests" />
      </Tabs>
      {currentTab === "fees" && <FeesForm onClose={onClose} />}
      {currentTab === "interests" && <CarriedForm onClose={onClose} />}
    </>
  );
};
